import {useTranslation} from 'react-i18next';
import {useCallback} from 'react';
import {CalendrierIcon} from '@/components/svg/CalendrierIcon';
import {
  DateRangeComponentProps,
  openDateRangeModal,
} from '../utils/dateRangeUtils';
import {BlueButton} from '@/components/Button/BlueButton';

/**
 * Bouton de sélection de plage de dates précise
 */
export const DateRangeSelectorButton: React.FC<DateRangeComponentProps> = ({
  selectedDateRange,
  onDateRangeChange,
}) => {
  const {t} = useTranslation();

  // Ouverture de la modale de sélection de plage de dates
  const handleOpenModal = useCallback(() => {
    openDateRangeModal(onDateRangeChange, selectedDateRange);
  }, [onDateRangeChange, selectedDateRange]);

  return (
    <BlueButton
      margin={0}
      leftIcon={<CalendrierIcon boxSize='15px' />}
      onClick={handleOpenModal}
      h='39px'
      w='107px'
      borderRadius='8px'
      flexShrink={0}
      fontSize='sm'
      isActive={!!selectedDateRange}
      texte={t('liste.date_range.select')}
    />
  );
};
